import { _LIST_PAGINATION_MODEL } from '../../app/models';

/**
 *  추천 상품 리스트 검색 박스 모델
 */
export const RECOMMEND_PRODUCT_LIST_SEARCH_DATA_MODEL = {
  /**
   *  추천 상품 타입
   */
  recommendProductType: null,
  /**
   *  추천인
   */
  adminName: null,
  /**
   *  메모
   */
  memo: null,
  /**
   *  추천 상품 생성일
   */
  createDate: {
    startDate: null,
    endDate: null,
  },
};

/**
 *  추천 상품 리스트 검색 옵션 모델
 */
export const RECOMMEND_PRODUCT_LIST_SEARCH_OPTION_MODEL = {
  /**
   *  추천 상품 타입
   */
  recommendProductType: null,
  /**
   *  추천인
   */
  adminName: null,
  /**
   *  메모
   */
  memo: null,
  /**
   *  추천 상품 생성일
   */
  createDate: null,
};

/**
 *  추천 상품에 연결할 아이템 리스트 필터 옵션 모델
 */
export const RECOMMEND_PRODUCT_ITEM_LIST_FILTER_OPTION_MODEL = {
  /**
   *  브랜드 번호
   */
  storeId: null,
  /**
   *  브랜드명
   */
  storeName: null,
  /**
   *  상품 번호
   */
  productId: null,
  /**
   *  상품명
   */
  productName: null,
  /**
   *  상품 1차 카테고리
   */
  mainCategory: null,
  /**
   *  상품 2차 카테고리
   */
  subCategory: null,
};

/**
 *  추천 상품에 연결할 아이템 리스트 필터 정렬 모델
 */
export const RECOMMEND_PRODUCT_ITEM_LIST_SORT_OPTION_MODEL = {
  /**
   *  상품 생성일
   */
  createDate: 'descend',
};

/**
 *  추천 상품 등록/복사 모델
 */
export const RECOMMEND_PRODUCT_SAVE_MODEL = {
  /**
   *  추천 상품 정보
   */
  recommendProductInfo: {
    /**
     *  추천 상품 타입
     */
    type: null,
    /**
     *  메모
     */
    memo: null,
    /**
     * 파일
     */
    attachment: [],
  },
  /**
   *  추천 상품 아이템 리스트
   */
  recommendProductItemList: {
    /**
     *  추천 상품에 연결할 아이템 리스트
     */
    itemList: {
      /**
       * 리스트
       */
      list: [],
      /**
       *  필터 옵션
       */
      filterOption: RECOMMEND_PRODUCT_ITEM_LIST_FILTER_OPTION_MODEL,
      /**
       *  정렬 옵션
       */
      sortOption: RECOMMEND_PRODUCT_ITEM_LIST_SORT_OPTION_MODEL,
      /**
       * pagination
       */
      pagination: _LIST_PAGINATION_MODEL,
    },
    /**
     *  선택된 추천 상품에 연결된 아이템 리스트
     */
    selectedItemList: {
      list: [],
      idList: [],
    },
  },
};
